import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const templatesUrl = `${SERVER_API}/templates`;

export const ADMINISTRATION_TEMPLATES = {
  ...generateCrudEndpoints(templatesUrl),
  VARIABLES: {
    method: 'GET',
    url: `${templatesUrl}/variables`,
  },
  RENDER(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${templatesUrl}/${id}/render`,
    };
  },
};
